import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { isNil } from 'Utility/ramdaReplacement';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'mgravisSymptoms'>[] = [];
const MgravisSymptoms = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'mgravisSymptoms'>>): React.JSX.Element => {
  const mgravisSymptoms = filterDocumentsByType(documents, ['mgravisSymptoms']).sort(sortDocumentsDescending).at(0);

  return (
    <HistorySection
      headerText={fm('diagnosis.mgravis.symptoms.title')}
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'mgravisSymptoms',
              startEdit(mgravisSymptoms ?? {}, 'mgravisSymptoms'),
              'general.edit',
              undefined,
              true,
              !isNil((mgravisSymptoms ?? {})._lockedFor),
              undefined,
              undefined,
              mgravisSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(mgravisSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('general.date')}
          value={
            mgravisSymptoms?.date ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>{formatPartialDate(mgravisSymptoms.date)}</div>
            ) : (
              ' - '
            )
          }
        />

        <HistoryRowVerticalItem header={fm('diagnosis.mgravis.symptoms.age')} value={mgravisSymptoms?.age} />

        <HistoryRowVerticalItem
          header={fm('diagnosis.mgravis.symptoms.location')}
          value={
            mgravisSymptoms?.symptomLocation?.length
              ? mgravisSymptoms.symptomLocation.map(item => fm('diagnosis.mgravis.symptoms.' + item))
              : ' - '
          }
        />
      </React.Fragment>
    </HistorySection>
  );
};

export default MgravisSymptoms;
